
import * as THREE from "../../libs/three.js/build/three.module.js";

export class CrossSectionProfile extends THREE.Object3D {

	constructor() {
		super();

		this.constructor.counter = (this.constructor.counter === undefined) ? 0 : this.constructor.counter + 1;
		this.name = "cross_section_" + this.constructor.counter;

		// Transect line endpoints (world-space Vector3)
		this.transectLine = { start: null, end: null };

		// Swath width in meters (1 foot default)
		this.swathWidth = 0.3048;

		// Computed transect length in meters
		this.length = 0;

		// Binned profile points: [{ distanceAlong, elevation }]
		// Raw bin medians before smoothing
		this.pointsRaw = [];

		// Smoothed profile points (moving average)
		this.points = [];

		// Outlier filter settings and results
		this.outlierFilter = {
			enabled: true,
			method: "std_dev",
			threshold: 2.0,
			pointsExcluded: 0
		};

		// Intersecting landmarks from FeatureZones
		this.intersectingLandmarks = [];

		// Intersecting curb reveal measurements
		this.intersectingCurbReveals = [];

		// Computed metrics
		this.computedMetrics = {
			highPoint: null,
			lowPoint: null,
			slopes: []
		};

		// Datum offset (populated by Feature 2 integration)
		this.datumOffset = {
			applied: false,
			referenceLandmarkId: null,
			offsetValue: null
		};

		this.initialized = false;
		this.phase = "drawing";
	}
}
